import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import axios from 'axios';
import { ErrorBoundary } from "react-error-boundary";
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import {
  UUT, 
  UUTLC, 
  THEME_HEADER,
  TIMEZONE_HEADER,
  PRIMARY_COLOR_HEADER,
  MAINTENANCE_MODE,  
  BACKEND_URL,
} from './config';
import MaintenanceWindow from './components/maintenance'; 
import { ErrorFallback } from './components/general';
import { getThemeFromLocalStorage } from './slices/themeSlice';

// Backend
if (!BACKEND_URL) {
  console.error('Internal connection error!');
}

// Axios Settings
axios.defaults.headers.common[UUT] = localStorage.getItem(UUTLC);
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Content-type'] = 'application/json';
axios.defaults.headers.common[THEME_HEADER] = getThemeFromLocalStorage();
axios.defaults.headers.common[TIMEZONE_HEADER] = Intl.DateTimeFormat().resolvedOptions().timeZone;
axios.defaults.headers.common[PRIMARY_COLOR_HEADER] = store.getState().user.value.primaryColor;
//

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {
      MAINTENANCE_MODE ?
      <MaintenanceWindow /> :
      <ReduxProvider store={store}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <App/>
        </ErrorBoundary>
      </ReduxProvider>
    }
  </React.StrictMode>  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
